<template lang="pug">
    div
        Poptip(width="600" transfer style="display:inline")
            Button(shape="circle" icon="md-information-circle" size="small" type="info" ghost) {{ infoBtnText }}
            div(slot="title")
                p Connect to your nodes with ssh keys
            div(slot="content")
                div
                    p You can use <mark> default </mark> ssh key by adding following public key to your servers' <mark>~/.ssh/authorized_keys</mark>
                    Card {{ $store.state.frontendConfigs.nodeConnectSSHPublicKey }}
                    p You can also upload your own keys at <router-link :to="{ name: 'sshkeys'}" target="_blank">ssh keys manage</router-link>
</template>
<script>
export default {
    name: "ExplainPrivateKeys",
    props: { infoBtnText: { type: String, default: "How to use ssh key" } },
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {};
    },
    methods: {},
    mounted() {},
    computed: {},
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainPrivateKeys.vue